module.exports = __webpack_public_path__ + "static/langojango-thai-language-phrasebook-49d3f348a2419d4f218b32d3405994f4.png";